import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

// Définir l'état initial
const initialState = {
  termsheets: []
};

// Créer le slice Redux
const termsheetSlice = createSlice({
  name: 'termsheet',
  initialState,
  reducers: {
    addTermsheet: (state) => {
      state.termsheets.push({
        id: uuidv4(),
        tradePartnerName: '',
        companyName: '',
        address: '',
        countryOfIncorporation: '',
        tradedGoodsDescription: '',
        creditLimit: '',
        tenor: '',
        currency: 'USD',
        percentageFinancing: '90',
        discountRateAnnualized: '',
        facilityFee: '',
        processingFee: '',
        facilitySetupFee: '',
        comments: ''
      });
    },
    updateTermsheet: (state, action) => {
      const { id, name, value } = action.payload;
      const termsheet = state.termsheets.find((t) => t.id === id);
      if (termsheet) {
        termsheet[name] = value;
      }
    },
    removeTermsheet: (state, action) => {
      const id = action.payload;
      state.termsheets = state.termsheets.filter((t) => t.id !== id);
    },
  },
});

export const { addTermsheet, updateTermsheet, removeTermsheet } = termsheetSlice.actions;

export default termsheetSlice.reducer;
